/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Credits_SceneInputs */

const en_settings_credits_scene = /** @type {(inputs: Settings_Credits_SceneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scene`)
};

const zh_settings_credits_scene = /** @type {(inputs: Settings_Credits_SceneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`场景`)
};

/**
* | output |
* | --- |
* | "Scene" |
*
* @param {Settings_Credits_SceneInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_credits_scene = /** @type {((inputs?: Settings_Credits_SceneInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Credits_SceneInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_credits_scene(inputs)
	return zh_settings_credits_scene(inputs)
});
export { settings_credits_scene as "settings.credits.scene" }